import { errorHandler } from '../../middleware'
import smartAuthAPI from '../smartbestbuys-api'
import { ProductCreationInfo } from './types'

export const fetchCreationInfoAPI = errorHandler<ProductCreationInfo>(async () => {
  const path = `/products/creation-info`
  return smartAuthAPI.get(path)
})
